import type React from 'react';
import { Avatar, Tooltip } from 'antd';
import dayjs from 'dayjs';
import type { ComparisonReportColumnConfig } from '../config/tpoGenConfig';

const EMAIL_SEGMENT_RE = /[._-]/;

const getInitialsFromEmail = (email: string): string => {
    const namePart = email.split('@')[0];
    const segments = namePart.split(EMAIL_SEGMENT_RE);
    return segments
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0].toUpperCase())
        .join('');
};

const renderAvatar = (text: string): React.ReactNode => {
    if (!text) return null;
    const initials = getInitialsFromEmail(text);
    return (
        <div className="flex items-center gap-2">
            <Avatar size={32}>{initials}</Avatar>
            <span>{text}</span>
        </div>
    );
};

const renderDate = (ts: number | string): React.ReactNode => {
    if (!ts) return null;
    const parsed = typeof ts === 'number' ? dayjs.unix(ts) : dayjs(ts);
    return (
        <Tooltip title={parsed.toDate().toLocaleString()} showArrow={false}>
            <span>{parsed.fromNow()}</span>
        </Tooltip>
    );
};

const renderCount = (count: number): React.ReactNode => {
    if (count == null) return null;
    return (
        <span className="inline-flex items-center rounded-lg bg-[#F7F5FF] px-3 py-px text-xs font-medium text-[#44338A]">
            {count}
        </span>
    );
};

const renderText = (value: string | number): React.ReactNode => {
    if (value == null) return null;
    return <span>{value}</span>;
};

const renderArrayText = (values: string[]): React.ReactNode => {
    if (!values?.length) return null;
    return <span>{values.join(', ')}</span>;
};

const CELL_RENDERERS: Record<ComparisonReportColumnConfig['type'], (value: any) => React.ReactNode> = {
    avatar: renderAvatar,
    date: renderDate,
    count: renderCount,
    text: renderText,
    arrayText: renderArrayText,
};

export default CELL_RENDERERS;
